const Tooltip = {
  baseStyle: {
    backgroundColor: 'blue.300',
    borderRadius: '10px',
    padding: '10px',
  },
}

export default Tooltip
